import { render, staticRenderFns } from "./extendElement.vue?vue&type=template&id=6b12da2b&"
import script from "./extendElement.vue?vue&type=script&lang=js&"
export * from "./extendElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports